import React from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import CustomModal from "../Modals/CustomModal";
import { BASE, BORDER, BRAND, GREY } from "../../utils/constants/colors";
import { fontSize, fontWeight } from "../../utils/constants/UI";
import { PROFILE_PATH } from "../../utils/constants/routes";
import { useTour } from "../../context/TourContext";

const LEARNING_CENTER_TAB = "LearningCenter";

const TourSkipModal = () => {
  const navigate = useNavigate();
  const { skipModalOpen, closeSkipModal } = useTour();

  const handleClose = () => {
    window.dispatchEvent(new CustomEvent("__tour:skipModalClosed"));
    closeSkipModal();
  };

  const handleGoToLearningCenter = () => {
    handleClose();
    navigate(`${PROFILE_PATH}?tab=${LEARNING_CENTER_TAB}`);
  };

  return (
    <CustomModal
      open={skipModalOpen}
      onClose={handleClose}
      width="420px"
      variant="primary"
      header={{
        heading: {
          id: "skip-modal-heading",
          label: "Skipping for now?",
        },
      }}
    >
      <Box style={{ padding: "4px 0 8px" }}>
        <p style={{
          margin: 0,
          fontSize: fontSize.SM,
          fontWeight: fontWeight.REGULAR,
          color: GREY.SECONDARY,
          lineHeight: "22px",
        }}>
          No worries! Tours are always available in the Learning Center.
        </p>

        <Box style={{
          marginTop: "16px",
          padding: "12px 16px",
          border: `1px solid ${BORDER.DEFAULT}`,
          borderRadius: "8px",
          background: BASE.BACKGROUND_LIGHT,
        }}>
          <p style={{
            margin: "0 0 10px 0",
            fontSize: "10px",
            fontWeight: fontWeight.SEMIBOLD,
            color: GREY.TERTIARY,
            textTransform: "uppercase",
            letterSpacing: "0.07em",
          }}>
            Access Anytime From:
          </p>
          <Box style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <span style={{ fontSize: fontSize.SM, fontWeight: fontWeight.MEDIUM, color: GREY.PRIMARY, lineHeight: "20px" }}>
              Settings{" "}
              <span style={{ color: GREY.TERTIARY, fontWeight: fontWeight.REGULAR }}>{"→"}</span>{" "}
              <strong>Learning Center</strong>
            </span>
          </Box>
        </Box>

        <button
          onClick={handleGoToLearningCenter}
          style={{
            display: "block",
            width: "100%",
            marginTop: "20px",
            padding: "10px 20px",
            background: BRAND.PRIMARY,
            color: BASE.WHITE,
            border: "none",
            borderRadius: "7px",
            fontSize: fontSize.SM,
            fontWeight: fontWeight.SEMIBOLD,
            cursor: "pointer",
            lineHeight: "20px",
            letterSpacing: "0.01em",
            fontFamily: "inherit",
          }}
        >
          Go to Learning Center
        </button>
      </Box>
    </CustomModal>
  );
};

export default TourSkipModal;
